import React from 'react';
import { Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';
import type { SaveStatus } from './hooks/useSettingsSectionSave';

interface Props {
  title: string;
  description?: string;
  children: React.ReactNode;
  saveLabel?: string;
  onSave?: () => void;
  saving?: boolean;
  saveStatus?: SaveStatus;
  footer?: React.ReactNode;
}

const SettingsSectionShell: React.FC<Props> = ({
  title,
  description,
  children,
  saveLabel = 'Save',
  onSave,
  saving = false,
  saveStatus = 'idle',
  footer,
}) => {
  return (
    <div className="settings-section-page">
      <header className="settings-section-header">
        <div>
          <h1 className="settings-section-title">{title}</h1>
          {description && <p className="settings-section-desc">{description}</p>}
        </div>
        {onSave && (
          <div className="settings-section-header-actions">
            {saveStatus === 'error' && (
              <span className="settings-save-feedback settings-save-feedback--error" role="alert">
                <AlertTriangle size={14} aria-hidden />
                Save failed
              </span>
            )}
            {saveStatus === 'saved' && (
              <span className="settings-save-feedback settings-save-feedback--saved">
                <CheckCircle2 size={14} aria-hidden />
                Saved
              </span>
            )}
            <button
              type="button"
              className="pm-btn pm-btn-primary pm-btn-sm"
              onClick={onSave}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Loader2 size={14} className="settings-spin" aria-hidden />
                  Saving…
                </>
              ) : (
                saveLabel
              )}
            </button>
          </div>
        )}
      </header>
      <div className="settings-section-body">{children}</div>
      {footer && <footer className="settings-section-footer">{footer}</footer>}
    </div>
  );
};

export default SettingsSectionShell;
